// todo move this file to module
export const OrderOnUnAuthenticatedShoppingCart = {
    '1': 'فعال',
    '0': 'غیرفعال',
}
